import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RedirectComentarioComponent } from './redirect.comentario';
import { RedirectLecturaComponent } from './redirect.lecturabilidad';
import { RedirectBaseComponent } from './redirect.base';
import { RedirectCambioComponent } from './redirect.cambio';
import { RedirectUsuarioComponent } from './redirect.usuario';
import { RedirectTotalArticuloComponent } from './redirect.totalarticulo';
import { RedirectTotalVistaComponent } from './redirect.totalvista';

@NgModule({
  declarations: [RedirectTotalArticuloComponent,RedirectTotalVistaComponent,RedirectComentarioComponent, RedirectLecturaComponent,RedirectBaseComponent, RedirectCambioComponent,RedirectUsuarioComponent],
  imports: [
    CommonModule,
  ],
  exports:[RedirectTotalArticuloComponent,RedirectTotalVistaComponent,RedirectComentarioComponent,RedirectLecturaComponent, RedirectBaseComponent,RedirectCambioComponent,RedirectUsuarioComponent]
})
export class RedirectModule { }
